export default {
  namespaced: true,
  state: {
    classroomsData: [],
    studentsData: [],
    studentsDataMapLogin: [],
    studentSelectInvisible: true,
    defaultClassroom: undefined,
    defaultStudent: undefined
  },
  getters: {
    state: (state) => state
  },
  actions: {
    setClassroomsData ({ commit }, data) {
      commit('setClassroomsData', data)
    },
    setStudentsData ({ commit }, data) {
      commit('setStudentsData', data)
    },
    addStudentsData ({ commit }, data) {
      commit('addStudentsData', data)
    },
    setStudentsDataMapLogin ({ commit }, data) {
      commit('setStudentsDataMapLogin', data)
    },
    setStudentSelectInvisible ({ commit }, visible) {
      commit('setStudentSelectInvisible', visible)
    },
    setDefaultClassroom ({ commit }, data) {
      commit('setDefaultClassroom', data)
    },
    setDefaultStudent ({ commit }, data) {
      commit('setDefaultStudent', data)
    }
  },
  mutations: {
    setClassroomsData (state, data) {
      state.classroomsData = data
    },
    setStudentsData (state, data) {
      state.studentsData = data
    },
    addStudentsData (state, data) {
      state.studentsData.push(data)
    },
    setStudentsDataMapLogin (state, data) {
      state.studentsDataMapLogin = data
    },
    setStudentSelectInvisible (state, visible) {
      state.studentSelectInvisible = visible
    },
    setDefaultClassroom (state, data) {
      state.defaultClassroom = data
    },
    setDefaultStudent (state, data) {
      state.defaultStudent = data
    }
  }
}
